<script setup lang="ts">
import { RouterView } from "vue-router";
import AssistantDrawer from "@/widgets/AssistantDrawer.vue";
import InstallPrompt from "@/widgets/InstallPrompt.vue";
import OfflineBadge from "@/widgets/OfflineBadge.vue";
import MobileTabBar from "@/widgets/MobileTabBar.vue";
import MobileFab from "@/widgets/MobileFab.vue";
import MasterKeyDialog from "@/widgets/MasterKeyDialog.vue";
</script>

<template>
  <RouterView />
  <AssistantDrawer />
  <InstallPrompt />
  <OfflineBadge />
  <MobileTabBar />
  <MobileFab />
  <MasterKeyDialog />
</template>
